import { Logger } from '@/common/helpers/Logger';

export function loadScript(src, onload = null, onerror = null, immediate = true) {
  Logger.log(src + ' is dynamically loaded')
  const script = document.createElement('script')
  script.src = src
  script.onload = onload
  script.onerror = onerror
  script.type = 'text/javascript'
  const addScript = () => document.body.appendChild(script)
  if (immediate) {
    addScript()
  } else {
    window.addEventListener('load', addScript)
  }
}
